import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import {
    ResponsiveSidebarDialog,
    ModalTitle,
    ModalContent,
    StickyModalActions,
    SecondaryButton,
    PrimaryButton,
} from '@/styles/blocks';
import { Body1 } from '../blocks';

// `usePanelSubject` holds the transition that opened this and replays it on discard.
const DiscardChangesModal = ({ open, onCancel, onDiscard }) => (
    <ResponsiveSidebarDialog open={open} onClose={onCancel}>
        <ModalTitle title="Discard unsaved changes?" onClose={onCancel} />
        <ModalContent width={420}>
            <Grid
                container
                css={css`
                    padding: 8px 0 24px;
                `}
            >
                <Body1>This subregion has changes that have not been saved yet.</Body1>
            </Grid>
        </ModalContent>
        <StickyModalActions>
            <Grid item>
                <SecondaryButton onClick={onCancel}>Keep Editing</SecondaryButton>
            </Grid>
            <Grid item>
                <PrimaryButton onClick={onDiscard}>Discard Changes</PrimaryButton>
            </Grid>
        </StickyModalActions>
    </ResponsiveSidebarDialog>
);

export default DiscardChangesModal;
